import { render, staticRenderFns } from "./typeTabs.vue?vue&type=template&id=45a545a5&"
import script from "./typeTabs.vue?vue&type=script&lang=js&"
export * from "./typeTabs.vue?vue&type=script&lang=js&"
import style0 from "./typeTabs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports